export { ProductCardHeading } from './product-card-heading';
